import React, { Component } from 'react';
import { noAvailableRecordIcon } from '../../../Images/NoAvailableSVG';
import { Singleton } from '../../../js/Singleton';
import NoAvailableRecordComponent from '../FloatingSideComponents/NoAvailableRecordComponent';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { DRAGGABLE_WINDOWS } from '../../../constants'

export default class NoAvailableRecordExpanded extends Component {
  constructor(props){
    super(props);
    this.sharedData = new SingletonSharedData();
  }
  render() {
    return (
      <div className={"fullSize "  + (this.sharedData.getWindowExpandedActive() !== DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD ? "height0" : "")}
        key="noAvailableExpandedRecord">
        {CUSTOM_COMPONENTS["sideBarHeader"](noAvailableRecordIcon, new Singleton().getText("GUICommonMenudisableHistory"))}
        <NoAvailableRecordComponent
        floating={false}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/ExpandedBar/NoAvailableRecordExpanded.jsx